import { render, staticRenderFns } from "./AudioFileUpload.vue?vue&type=template&id=496bb93a"
import script from "./AudioFileUpload.vue?vue&type=script&lang=js"
export * from "./AudioFileUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports